/**
 * ===============================================
 * CUSTOM PRODUCT BUILDER - JAVASCRIPT
 * La Scelta del Lupo - Configuratore Pettorina
 * ===============================================
 *
 * STRUTTURA DOM:
 * - .cpb-root                    → Container principale
 * - .cpb-product-builder         → Wrapper builder
 * - .cpb-preview-container       → Anteprima immagine
 * - .cpb-panels-container        → Pannelli configurazione
 * - .cpb-category                → Categoria
 * - .cpb-option                  → Opzione selezionabile
 * - .cpb-option.cpb-active       → Opzione selezionata
 * - .cpb-product-actions         → Azioni (qty, cart)
 *
 * CLASSI CATEGORIA (kebab-case):
 * - .cpb-category.taglia         → Taglia (text: S, M, L/XL)
 * - .cpb-category.colore-anelli  → Colore Anelli (img)
 * - .cpb-category.sopra          → Fettuccia Sopra (img)
 * - .cpb-category.centrale-sopra → Fettuccia Centrale Sopra (img, IMP)
 * - .cpb-category.centrale-destra→ Fettuccia Centrale Destra (img)
 * - .cpb-category.centrale-sinistra → Fettuccia Centrale Sinistra (img)
 * - .cpb-category.centrale-sotto → Fettuccia Centrale Sotto (img)
 * - .cpb-category.sotto          → Fettuccia Sotto (img)
 *
 * CLASSI IMP (gestite da cpb-waterproof-enhancer.liquid):
 * - .ldl-imp-wrapper, .ldl-has-imp-badge, .ldl-imp-badge
 *
 * ===============================================
 */

(function($) {
  'use strict';

  // Configurazione
  const CPB_CONFIG = {
    debug: false,
    selectors: {
      root: '.cpb-root, #product-builder',
      option: '.cpb-option',
      activeOption: '.cpb-option.cpb-active',
      category: '.cpb-category',
      optionLabel: '.cpb-option-label',
      optionInfoLabel: '.cpb-option-info-label',
      addToCart: '.cpb-add-to-cart-button',
      price: '.cpb-product-price',
      quantity: '.cpb-quantity-value',
      // Categorie specifiche (classi kebab-case)
      categories: {
        taglia: '.cpb-category.taglia',
        coloreAnelli: '.cpb-category.colore-anelli',
        sopra: '.cpb-category.sopra',
        centraleSopra: '.cpb-category.centrale-sopra',
        centraleDestra: '.cpb-category.centrale-destra',
        centraleSinistra: '.cpb-category.centrale-sinistra',
        centraleSotto: '.cpb-category.centrale-sotto',
        sotto: '.cpb-category.sotto'
      },
      // Tutte le fettucce
      allFettucce: '.cpb-category.sopra, .cpb-category.centrale-sopra, .cpb-category.centrale-destra, .cpb-category.centrale-sinistra, .cpb-category.centrale-sotto, .cpb-category.sotto'
    },
    pollInterval: 100,
    maxPollAttempts: 50
  };

  // Utility: Log debug
  function log(message, data) {
    if (CPB_CONFIG.debug) {
      console.log('[CPB Custom]', message, data || '');
    }
  }

  // Utility: Attendi che CPB sia pronto
  function waitForCPB(callback) {
    let attempts = 0;
    const poll = setInterval(function() {
      attempts++;
      const options = document.querySelectorAll(CPB_CONFIG.selectors.option);

      if (options.length > 0) {
        clearInterval(poll);
        log('CPB pronto dopo ' + (attempts * CPB_CONFIG.pollInterval) + 'ms');
        callback();
      }

      if (attempts >= CPB_CONFIG.maxPollAttempts) {
        clearInterval(poll);
        log('Timeout attesa CPB');
      }
    }, CPB_CONFIG.pollInterval);
  }

  // Utility: Ottieni tutte le selezioni correnti
  function getCurrentSelections() {
    const selections = {};
    document.querySelectorAll(CPB_CONFIG.selectors.category).forEach(function(category) {
      const categoryTitle = category.querySelector('.cpb-category-title span');
      const activeOption = category.querySelector(CPB_CONFIG.selectors.activeOption);

      if (categoryTitle && activeOption) {
        const label = activeOption.querySelector(CPB_CONFIG.selectors.optionLabel);
        selections[categoryTitle.textContent.trim()] = label ? label.textContent.trim() : '';
      }
    });
    return selections;
  }

  // Utility: Osserva cambiamenti nelle selezioni
  function observeSelections(callback) {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' &&
            mutation.attributeName === 'class' &&
            mutation.target.classList.contains('cpb-option')) {
          callback(mutation.target);
        }
      });
    });

    const root = document.querySelector(CPB_CONFIG.selectors.root);
    if (root) {
      observer.observe(root, {
        attributes: true,
        subtree: true,
        attributeFilter: ['class']
      });
    }

    return observer;
  }

  // Auto-deselect engraving checkbox when non-IMP ribbon selected in Centrale Sopra
  // Uses click event in CAPTURE phase to act BEFORE React removes the checkbox from DOM
  function initAutoDeselectEngraving() {
    console.log('[CPB Auto-deselect] Registrazione click listener (capture phase)');

    document.addEventListener('click', function(e) {
      // Find the clicked cpb-option inside centrale-sopra
      var clickedOption = e.target.closest('.cpb-category.centrale-sopra .cpb-option');
      if (!clickedOption) return;

      // Skip if clicking the already-active option
      if (clickedOption.classList.contains('cpb-active')) return;

      // Check if the clicked option is non-IMP
      var optionLabel = clickedOption.querySelector('.cpb-option-label');
      if (!optionLabel) return;
      var labelText = optionLabel.textContent.trim().toUpperCase();
      var isIMP = labelText.startsWith('IMP');

      console.log('[CPB Auto-deselect] Click su Centrale Sopra:', labelText, 'isIMP:', isIMP);

      if (!isIMP) {
        // Non-IMP clicked: uncheck the engraving checkbox BEFORE React processes
        var checkboxLabel = document.querySelector('.cpb-category.vuoi-incidere-nome-numero .cpb-checkbox label');
        var checkboxInput = document.querySelector('.cpb-category.vuoi-incidere-nome-numero input[type="checkbox"]');

        if (checkboxInput && checkboxInput.checked) {
          console.log('[CPB Auto-deselect] Deseleziono checkbox incisione (pre-React)');
          if (checkboxLabel) {
            checkboxLabel.click();
          } else {
            checkboxInput.click();
          }
        } else {
          console.log('[CPB Auto-deselect] Checkbox non trovata o gia deselezionata');
        }
      }
    }, true); // CAPTURE phase: fires before React event handlers

    console.log('[CPB Auto-deselect] Click listener attivato');
  }

  // Auto-deselect "Taglia Personalizzata" checkbox when size changes
  // Uses click event in CAPTURE phase to act BEFORE React removes the checkbox from DOM
  function initAutoDeselectTagliaPersonalizzata() {
    var tagliaCheckboxSelectors = [
      '.cpb-category.Taglia-Personalizzata-S',
      '.cpb-category.Taglia-Personalizzata-M',
      '.cpb-category.Taglia-Personalizzata-L-XL'
    ];
    var allTagliaCheckboxes = tagliaCheckboxSelectors.join(', ');

    document.addEventListener('click', function(e) {
      // Find the clicked cpb-option inside taglia category
      var clickedOption = e.target.closest('.cpb-category.taglia .cpb-option');
      if (!clickedOption) return;

      // Skip if clicking the already-active option
      if (clickedOption.classList.contains('cpb-active')) return;

      console.log('[CPB Auto-deselect Taglia] Cambio taglia rilevato');

      // Find any checked Taglia Personalizzata checkbox and uncheck it
      var categories = document.querySelectorAll(allTagliaCheckboxes);
      categories.forEach(function(cat) {
        var checkboxInput = cat.querySelector('input[type="checkbox"]');
        if (checkboxInput && checkboxInput.checked) {
          var checkboxLabel = cat.querySelector('.cpb-checkbox label');
          console.log('[CPB Auto-deselect Taglia] Deseleziono checkbox taglia personalizzata');
          if (checkboxLabel) {
            checkboxLabel.click();
          } else {
            checkboxInput.click();
          }
        }
      });
    }, true); // CAPTURE phase

    console.log('[CPB Auto-deselect Taglia] Click listener attivato');
  }

  // Inizializzazione principale
  function init() {
    log('Inizializzazione CPB Custom JS');

    waitForCPB(function() {
      log('Selezioni iniziali:', getCurrentSelections());

      // Osserva cambiamenti
      observeSelections(function(changedOption) {
        if (changedOption.classList.contains('cpb-active')) {
          log('Nuova selezione:', changedOption);
          // Qui puoi aggiungere logica custom quando cambia una selezione
        }
      });

      // === AGGIUNGI QUI LE TUE CUSTOMIZZAZIONI ===

      // Auto-deselect engraving checkbox when switching from IMP to non-IMP in Centrale Sopra
      initAutoDeselectEngraving();

      // Auto-deselect Taglia Personalizzata checkbox when size changes
      initAutoDeselectTagliaPersonalizzata();

      // Esempio: Log quando si clicca aggiungi al carrello
      $(document).on('click', CPB_CONFIG.selectors.addToCart, function() {
        log('Aggiungi al carrello cliccato');
        log('Configurazione finale:', getCurrentSelections());
      });

    });
  }

  // Avvia quando DOM pronto
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Esponi utility globalmente per debug
  window.CPBCustom = {
    getSelections: getCurrentSelections,
    config: CPB_CONFIG
  };

})(jQuery);